import Async from "components/DesignSystem/AsyncComponents/Async";
import Card from "components/DesignSystem/Card/Card";
import { Skeleton } from "components/DesignSystem/Skeleton/Skeleton";
import DashboardContainer from "components/dashboard/DashboardContainer";
import { DnDArea } from "components/design/UploadFileSection";
import { BULK_GROUP_ENTITY_TEMPLATE_URL } from "types/contants/sampleExcelSheet";
import { BroadcastCsvHeader } from "components/BroadcastMessage/BroadcastCsvHeader";
import { BulkActionCsvTable } from "./BulkActionCsvTable";
import { ParsedListForBulkCart } from "types/Models/serviceTeam";
import { stopPropagation } from "utils/stopPropagation";
import { PaginationHandler } from "components/DesignSystem/Pagination/Pagination";

type UploadCsvForBulkActionProps = {
  file: File | null;
  parsedData: ParsedListForBulkCart[] | null;
  isLoading: boolean;
  pageNum: number;
  onCsvUpload: (file: File, page?: number) => Promise<void>;
  perPage: number;
  totalCount: number;
  totalPages: number;
};

export const UploadCsvForBulkCartAction = ({
  file,
  parsedData,
  isLoading,
  pageNum,
  onCsvUpload,
  perPage,
  totalCount,
  totalPages,
}: UploadCsvForBulkActionProps) => {
  const onDrop = async (files: File[]) => {
    const file = files[0];
    await onCsvUpload(file, pageNum);
  };

  const handlePageChange = (page: number) => {
    if (file) {
      onCsvUpload(file, page);
    }
  };

  return (
    <div className="t-flex-1 t-space-y-4" onClick={stopPropagation}>
      <BroadcastCsvHeader
        exampleTemplateUrl={BULK_GROUP_ENTITY_TEMPLATE_URL}
        customPagination={
          totalCount > 0 && (
            <PaginationHandler
              page_num={pageNum}
              per_page={perPage}
              total_count={totalCount}
              total_pages={totalPages}
              onPageNumChange={handlePageChange}
            />
          )
        }
        title="Upload a CSV with company and entity names to add or delete tasks"
        onDrop={onDrop}
      />
      <DashboardContainer.Content>
        <div className="t-h-full">
          {parsedData || isLoading ? (
            <Async.Root
              {...{ isLoading, isSuccess: !!parsedData, isEmpty: false }}
              renderOnLoad={
                <Card.Body className="t-space-y-3">
                  <Skeleton className="t-min-h-10" />
                  <Skeleton className="t-min-h-10" />
                  <Skeleton className="t-min-h-10" />
                </Card.Body>
              }
            >
              <Async.Empty>
                <div className="t-flex t-justify-center t-items-center t-h-full t-flex-col">
                  <p className="t-text-subtext t-text-text-100 t-m-0">
                    No entities found
                  </p>
                  <p className="t-text-body-sm t-text-text-30">
                    Please upload another file to see more entities.
                  </p>
                </div>
              </Async.Empty>
              <Async.Success>
                <BulkActionCsvTable list={parsedData || []} />
              </Async.Success>
            </Async.Root>
          ) : (
            <DnDArea
              multiple={false}
              onDrop={onDrop}
              accept={{ "text/csv": [".csv"] }}
              title="Click or drag and drop to upload the filled template"
              subText="File Format: csv"
            />
          )}
        </div>
      </DashboardContainer.Content>
    </div>
  );
};
